import { jsx as _jsx } from "react/jsx-runtime";
import { PAGINAS, ROUTES, FUNCIONALIDADES } from '../../../routes';
import { getTiposTermosDocumentos } from '../../../api';
import StatusPesquisar from '../../../components/status_pesquisar';
import GridBase from '../../../components/grid_base';
var COLUNAS = [
    { field: 'nome', headerName: 'Nome', width: 650 },
    { field: 'situacao', headerName: 'Situação', width: 150 },
];
export default function TiposTermosDocumentos() {
    return (_jsx(GridBase, { pagina: PAGINAS.CC_TIPOS_TERMOS_DOCUMENTOS, paginaPermissao: FUNCIONALIDADES.CC_TIPOS_TERMOS_DOCUMENTOS, rota: ROUTES.CC_TIPOS_TERMOS_DOCUMENTOS, columns: COLUNAS, filtrosIniciais: { situacao: '-1' }, fetchData: function (busca, filtros, paginacao) { return getTiposTermosDocumentos(busca, filtros.situacao === '-1' ? null : filtros.situacao, paginacao); }, renderFiltros: function (filtros, atualizar) { return (_jsx(StatusPesquisar, { StatusPesquisa: filtros.situacao, filtrarGrid: function (_, novaSituacao) {
                atualizar({ situacao: novaSituacao });
            } })); } }));
}
